import axios from "axios";
import { SERVER_URL } from "../const";
import Qs from 'qs';


export const getCCRDataService = async (ccrType, hsn) => {
  const token = localStorage.getItem('token');
  try {
    const params = {
      ccr_type: ccrType
    };

    if (hsn && hsn.length >= 6) {
      params.hsn_no = hsn;
    }

    const response = await axios.get(`${SERVER_URL}/ccr-details`, {
      params,
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching CCR data:', error);
    throw error;
  }
};

/**
 * Search HSN codes for autocomplete (with 2+ character minimum)
 * @param {string} searchTerm - Search prefix (minimum 2 characters)
 * @param {string} tradeType - IMPORT or EXPORT
 * @param {string} iecNo - IEC number
 * @returns {Promise<Array>} - List of matching HSN codes
 */
export const searchHSNCodesService = async (searchTerm, tradeType, iecNo) => {
  const token = localStorage.getItem('token');

  if (!searchTerm || searchTerm.length < 2) {
    return [];
  }

  try {
    const dataType = tradeType === 'IMPORT' ? 'CCR_IMPORT' : 'CCR_EXPORT';

    const response = await axios.get(`${SERVER_URL}/reference-data/lookup`, {
      params: {
        iec_no: iecNo,
        type: dataType,
        search: searchTerm
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.data?.data || [];
  } catch (error) {
    console.error('Error fetching HSN suggestions:', error);
    return [];
  }
};






